module.exports = __webpack_public_path__ + "static/media/Pic5.0d37adcc.png";